import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { DataSourceResponse, Executor } from '../../models';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class ExecutorService extends ApiService {
    endPoint = '/api/Executors';
    create(model: Executor) {
        return this.http.post(`${this.queueUrl}${this.endPoint}`, model);
    }
    edit(id: string, model: Executor) {
        return this.http.put(`${this.queueUrl}${this.endPoint}/${id}`, model);
    }
    get(id: string): Observable<Executor> {
        return this.http.get<Executor>(`${this.queueUrl}${this.endPoint}/${id}`);
    }
    delete(id: string) {
        return this.http.delete<any>(`${this.queueUrl}${this.endPoint}/${id}`);
    }
    getList(queryParams: any): Observable<DataSourceResponse<Executor>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.queueUrl}${this.endPoint}`, { params });
    }
}
